import request from '@/utils/request'

export function login(data) {
  return request({ url: '/app/auth/login', method: 'post', data })
}

export function register(data) {
  return request({ url: '/app/auth/register', method: 'post', data })
}

export function getProfile() {
  return request({ url: '/app/member/profile', method: 'get' })
}

export function submitKyc(data) {
  return request({ url: '/app/member/kyc', method: 'post', data })
}

export function listPayChannels(bizType) {
  return request({ url: '/app/pay/channels', method: 'get', params: { bizType } })
}

export function recharge(data) {
  return request({ url: '/app/member/recharge', method: 'post', data })
}

export function withdraw(data) {
  return request({ url: '/app/member/withdraw', method: 'post', data })
}

export function exchange(data) {
  return request({ url: '/app/member/exchange', method: 'post', data })
}

export function getLogs() {
  return request({ url: '/app/member/logs', method: 'get' })
}

export function getDailyRebates() {
  return request({ url: '/app/member/rebates', method: 'get' })
}

export function getMyOrders() {
  return request({ url: '/app/product/orders', method: 'get' })
}

export function getHome() {
  return request({ url: '/app/home/index', method: 'get' })
}

export function getProducts(category) {
  return request({ url: '/app/home/products', method: 'get', params: { category } })
}

export function buyProduct(data) {
  return request({ url: '/app/product/buy', method: 'post', data })
}

export function checkin() {
  return request({ url: '/app/checkin', method: 'post' })
}

export function getTeam() {
  return request({ url: '/app/team', method: 'get' })
}

export function upgradeProgress() {
  return request({ url: '/app/upgrade/progress', method: 'get' })
}

export function lotteryPrizes() {
  return request({ url: '/app/lottery/prizes', method: 'get' })
}

export function lotteryDraw() {
  return request({ url: '/app/lottery/draw', method: 'post' })
}

export function gameStatus() {
  return request({ url: '/app/game/status', method: 'get' })
}

export function gameFinish(data) {
  return request({ url: '/app/game/finish', method: 'post', data })
}

export function getNewsList() {
  return request({ url: '/app/content/news', method: 'get' })
}

export function getNewsDetail(id) {
  return request({ url: '/app/content/news/' + id, method: 'get' })
}

export function getSitePage(pageKey) {
  return request({ url: '/app/content/page/' + pageKey, method: 'get' })
}

export function getUnreadMessages() {
  return request({ url: '/app/content/messages/unread', method: 'get' })
}

export function markMessageRead(msgId) {
  return request({ url: '/app/content/messages/' + msgId + '/read', method: 'post' })
}
